import { Injectable, Component, OnInit, ViewContainerRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { Subject} from 'rxjs';
import { Observable } from 'rxjs';

import { BrowserWidthService } from "../../services/browser-width.service";

import { ModalDialogComponent, ModalDialogHost } from './modal-dialog.component';
import { ConfirmationModalComponent, ConfirmationModalOptions } from './confirmation-modal/confirmation-modal.component';
import { LoadingModalComponent, LoadingModalOptions } from './loading-modal/loading-modal.component';
import { MessageModalComponent, MessageModalOptions } from './message-modal/message-modal.component';

export { ModalDialogComponent, ModalDialogHost, ConfirmationModalComponent, ConfirmationModalOptions, LoadingModalComponent, LoadingModalOptions, MessageModalComponent, MessageModalOptions };

@Injectable()
export class ModalDialogService {
    private modalDialogContainer: ModalDialogContainerComponent
    private loadingDialog: LoadingModalComponent = null;

    constructor(
        public browserWidthService: BrowserWidthService
    ) {

    }

    registerModalContainer(container: ModalDialogContainerComponent) {
        this.modalDialogContainer = container;
    }

    private checkModalHostContainer() {
        if (!this.modalDialogContainer) {
            throw "No container found to host the modals! Please include <yeti-modal-dialog-container></yeti-modal-dialog-container> somewhere in your HTML file. Anywhere. Like, seriously, even at the top above your first <html> tag. Well, maybe you want it at the bottom of your <body> tag. Either way, just put the freaking tag in there or else you ain't getting no modals.";
        }
    }

    openModal(component: any, initData?: any): Observable<any> {
        var modal = this.dynamicallyLoadModal(component);

        if (initData && modal.init) {
            this.browserWidthService.setScroll(true);
            modal.init(initData);
        }
        return modal.modalClose;
    }

    private dynamicallyLoadModal(component: any): ModalDialogHost {
        this.checkModalHostContainer();

        var modalRef = this.modalDialogContainer.injectModalHost(component);
        var modalDialog = <ModalDialogHost>(modalRef.instance);

        modalDialog.readyForDestruction.subscribe(() => {
            this.modalDialogContainer.cleanModalHost(modalRef);
        });
        return modalDialog;
    }

    getConfirmation(options: ConfirmationModalOptions): Observable<boolean> {
        return this.openModal(ConfirmationModalComponent, options);
    }

    showMessage(options: MessageModalOptions) {
        return this.openModal(MessageModalComponent, options);
    }

    showLoading(options: LoadingModalOptions) {
        if (!this.loadingDialog) {
            this.loadingDialog = <LoadingModalComponent>this.dynamicallyLoadModal(LoadingModalComponent);
            this.loadingDialog.init(options);
        }
    }

    hideLoading() {
        if (this.loadingDialog) {
            (<ModalDialogHost>this.loadingDialog).close();
            this.loadingDialog = null;
        }
    }
}

@Component({
    moduleId: module.id.toString(),
    selector: 'yeti-modal-dialog-container',
    template: ''
})

export class ModalDialogContainerComponent implements OnInit {
    constructor(private _modalDialogService: ModalDialogService, private _viewRef: ViewContainerRef, private _componentResolver: ComponentFactoryResolver, public browserWidthService: BrowserWidthService) {
    }

    ngOnInit() {
        this._modalDialogService.registerModalContainer(this);
    }

    injectModalHost(component: any): any {
        return this._viewRef.createComponent(this._componentResolver.resolveComponentFactory(component));
    }

    cleanModalHost(modal: any) {
        this._viewRef.remove(this._viewRef.indexOf(modal));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/modal-dialog/modal-dialog.service.ts